<template>
  <v-card>
    <v-card-title>
      <p class="pl-6">{{ $tc("common.logo", 1) }}</p>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-col
      ><v-row
        ><v-file-input
          v-model="file"
          accept="image/*"
          :label="$t('common.select_picture')"
        ></v-file-input>
        <v-btn
          :loading="loading"
          :disabled="loading"
          color="blue-grey"
          class="ma-2 white--text"
          @click="onUpload"
        >
          {{ this.$t("common.send") }}
          <v-icon right dark> mdi-cloud-upload </v-icon>
        </v-btn>
      </v-row>
    </v-col>
  </v-card>
</template>

<script>
import ApiService from "@/utils/api.service"

export default {
  name: "LogoForm",
  data: () => ({
    file: null,
    loading: false,
  }),

  methods: {
    onUpload() {
      this.loading = true
      let formData = new FormData()
      formData.append("file", this.file, this.file.name)
      ApiService.post("/clients/logo", formData)
        .then(() => {
          this.$toast.success(this.$t("success.logo_added"))
        })
        .catch((error) => {
          console.log({ error })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
